'use client';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useEffect, useState } from 'react';
import Icon from '../Icon';
import { optionStyles } from './OptionButton';

const UploadButton = ({ children = '', name, id = name, value, disabled = false, xStyle = {}, onChange = null, multiple = false, setValue = null, ...props }) => {
	const [checked, setChecked] = useState(false);

	useEffect(() => {
		setChecked(value != null);
	}, [value]);

	useEffect(() => {}, [checked]);
	return (
		<span css={theme => optionStyles(theme, checked, xStyle)} checked={checked}>
			<input
				type="file"
				id={id}
				name={name}
				onChange={event => {
					setValue(multiple ? event.target.files : event.target.files[0]);
				}}
			/>
			<label htmlFor={id} className="!px-6">
				<span className="icon">{checked ? <Icon className="fi fi-br-check" /> : <Icon className="fi fi-br-file-add" />}</span>
				{children}
			</label>
		</span>
	);
};

export default UploadButton;
